import gql from 'graphql-tag'

export const SETORES_QUERY = gql`
  query Setores {
    setores {
      id
      nome
      divisao {
        id
        nome
      }
    }
  }
`
